import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import AnimatedBg from "react-animated-bg";
import { NavLink } from "react-router-dom";


const Navigation = () => {
    const title = {
      fontFamily: "'Satisfy', cursive",
      fontWeight: "bold",
    };
    return (
      <AnimatedBg
        colors={["#077b88", "#1f8893", "#38959f", "#51a2ab", "#6aafb7"]}
        duration={1.5}
        delay={0}
        timingFunction="ease-out"
        className="animated-section"
      >
        <Navbar collapseOnSelect expand="lg" sticky="top" variant="light">
          <Container>
            <Navbar.Brand href="#home" className="fs-2" style={title}>
              Debasree Bhowmik
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link className="fw-bold" href="#about-me">
                  About Me
                </Nav.Link>
                <Nav.Link className="fw-bold" href="#projects">
                  Projects
                </Nav.Link>
                <Nav.Link className="fw-bold">
                  <NavLink
                    to="/blog"
                    activeStyle={{ textDecoration: "none", color: "#000000" }}
                    style={{
                      textDecoration: "none",
                      color: "rgba(0,0,0,.55)",
                    }}
                  >
                    Blog
                  </NavLink>
                </Nav.Link>
                <Nav.Link className="fw-bold" href="#form">
                  Contact Me
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </AnimatedBg>
    );
};

export default Navigation;
